import { CustomFetchClient } from '@pkgs/api/utils/customFetchClient';
import { type HttpRequestConfig } from '@pkgs/api/types/http';
import { type ApiConfig } from '@pkgs/api/types/api';
import { SEARCH_API_ENV_URL_MAP } from '@pkgs/api/constants';

import { panic } from '../../src/utils/panic';

export const customInstance = async <T>(config: HttpRequestConfig, apiConfig?: ApiConfig): Promise<T> => {
  if (!apiConfig?.applicationKey) {
    panic('x-application-key is required');
  }

  return new CustomFetchClient({
    defaultBaseURL: SEARCH_API_ENV_URL_MAP[apiConfig?.environment ?? 'prod'],
  }).request<T>(config, apiConfig);
};
